/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Defines the system-wide role names for housing organization access control. These roles are used to manage permissions and access levels for users across the entire housing system, such as determining who can access the portal, perform administrative tasks, or design forms.
 * The HousingModuleRoleName enum provides a clear and consistent way to reference these system-wide roles throughout the application, ensuring that access control logic is centralized and maintainable.
 */
export enum HousingModuleRoleName {
    AGENT = 'Agent',
    BULK_AGENT = 'BulkAgent',
}
